import * as Blockly from 'blockly/core';
import 'blockly/blocks';
import { javascriptGenerator } from 'blockly/javascript';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import { DeviceTypes } from '../../../constants/DeviceModels';
import { BatchCycleStatus } from '../../../constants/BatchCycleStatus';

const STORAGE_PREFIX = 'blockly_var_';

const addCustomBlocks = () => {
  const deviceStatus = Object.values(DeviceStatus).map(v => [v, v]);
  const deviceType = Object.values(DeviceTypes).map(v => [v, v.toUpperCase()]);
  const batchCycleStatus = Object.values(BatchCycleStatus).map(v => [v, v]);

  const blockDefinitions = [
    {
      'type': 'block_error',
      'message0': 'Missing Block: %1',
      'args0': [
        {
          'type': 'field_label',
          'name': 'TYPE',
          'text': '',
        },
      ],
      'previousStatement': null,
      'nextStatement': null,
      'output': null,
      'colour': '#cc0000',
      'tooltip': 'This block is not available in the current version',
      'helpUrl': '',
    },
    {
      'type': 'block_console_log',
      'message0': 'print to console %1',
      'args0': [{
        'type': 'input_value',
        'name': 'TEXT',
        'check': ['String', 'Number', 'Boolean', 'Array'],
      }],
      'previousStatement': null,
      'nextStatement': null,
      'colour': 160,
      'tooltip': 'Prints the provided value to console',
      'helpUrl': '',
    },
    {
      'type': 'block_device_status',
      'message0': 'Device Status %1',
      'args0': [{
        'type': 'field_dropdown',
        'name': 'DEVICE_STATUS',
        'options': deviceStatus,
      }],
      'output': 'String',
      'colour': 230,
      'tooltip': 'Device status',
      'helpUrl': '',
    },
    {
      'type': 'block_device_type',
      'message0': 'Device Type %1',
      'args0': [{
        'type': 'field_dropdown',
        'name': 'DEVICE_TYPE',
        'options': deviceType,
      }],
      'output': 'String',
      'colour': 230,
      'tooltip': 'Device type',
      'helpUrl': '',
    },
    {
      'type': 'block_batch_cycle_status',
      'message0': 'Batch Cycle Status %1',
      'args0': [{
        'type': 'field_dropdown',
        'name': 'BATCH_CYCLE_STATUS',
        'options': batchCycleStatus,
      }],
      'output': 'String',
      'colour': 230,
      'tooltip': 'Batch Cycle Status',
      'helpUrl': '',
    },
    // Save localstorage variable
    {
      'type': 'block_save_variable',
      'message0': 'save %1 as %2',
      'args0': [
        {
          'type': 'input_value',
          'name': 'VALUE',
          'check': ['String', 'Number', 'Boolean', 'Array'],
        },
        {
          'type': 'field_input',
          'name': 'VAR_NAME',
          'text': 'variable_name',
        },
      ],
      'previousStatement': null,
      'nextStatement': null,
      'colour': 160,
      'tooltip': 'Saves a value to localStorage with the given variable name',
      'helpUrl': '',
    },
    // Load localstorage variable
    {
      'type': 'block_load_variable',
      'message0': 'load variable %1',
      'args0': [
        {
          'type': 'field_input',
          'name': 'VAR_NAME',
          'text': 'variable_name',
        },
      ],
      'output': null,
      'colour': 160,
      'tooltip': 'Loads a value from localStorage with the given variable name',
      'helpUrl': '',
    },
    // Delete localstorage variable
    {
      'type': 'block_delete_variable',
      'message0': 'delete variable %1',
      'args0': [
        {
          'type': 'field_input',
          'name': 'VAR_NAME',
          'text': 'variable_name',
        },
      ],
      'previousStatement': null,
      'nextStatement': null,
      'colour': 160,
      'tooltip': 'Deletes a variable from localStorage',
      'helpUrl': '',
    },
  ];

  Blockly.common.defineBlocksWithJsonArray(blockDefinitions);

  javascriptGenerator.forBlock['block_error'] = function(block) {
    return '// Missing block: ' + block.getFieldValue('TYPE') + '\n';
  };

  javascriptGenerator.forBlock['block_console_log'] = function(block) {
    const value = javascriptGenerator.valueToCode(block, 'TEXT', javascriptGenerator.ORDER_NONE) || '""';
    return `console.log(${value});\n`;
  };

  javascriptGenerator.forBlock['block_device_status'] = function(block) {
    const value = block.getFieldValue('DEVICE_STATUS');
    return [JSON.stringify(value), javascriptGenerator.ORDER_ATOMIC];
  };

  javascriptGenerator.forBlock['block_device_type'] = function(block) {
    const value = block.getFieldValue('DEVICE_TYPE');
    return [JSON.stringify(value), javascriptGenerator.ORDER_ATOMIC];
  };

  javascriptGenerator.forBlock['block_batch_cycle_status'] = function(block) {
    const value = block.getFieldValue('BATCH_CYCLE_STATUS');
    return [JSON.stringify(value), javascriptGenerator.ORDER_ATOMIC];
  };

  // Localstorage generators
  javascriptGenerator.forBlock['block_save_variable'] = function(block) {
    const value = javascriptGenerator.valueToCode(block, 'VALUE', javascriptGenerator.ORDER_NONE) || '""';
    const varName = block.getFieldValue('VAR_NAME');
    return `localStorage.setItem('${STORAGE_PREFIX}${varName}', JSON.stringify(${value}));\n`;
  };

  javascriptGenerator.forBlock['block_load_variable'] = function(block) {
    const varName = block.getFieldValue('VAR_NAME');
    const code = `JSON.parse(localStorage.getItem('${STORAGE_PREFIX}${varName}') || 'null')`;
    return [code, javascriptGenerator.ORDER_FUNCTION_CALL];
  };

  javascriptGenerator.forBlock['block_delete_variable'] = function(block) {
    const varName = block.getFieldValue('VAR_NAME');
    return `localStorage.removeItem('${STORAGE_PREFIX}${varName}');\n`;
  };
};

export default addCustomBlocks;
